import {Toaster, useMediaQuery} from '@cashiaApp/web-components';
import {Route, Routes} from 'react-router-dom';

import TermsAndConditions from '../pages/TermsAndConditions';
import NotFound from '../pages/errors/NotFound';
import ShopPage from '../pages/shop';
import ShopErrorPage from '../pages/shop/Error';
import ShopSuccessPage from '../pages/shop/Success';
import CheckoutComponentV2 from '../pages/v2/checkout';
import HostPageV2 from '../pages/v2/host';
import PaymentPageV2 from '../pages/v2/payment';

const AppRoutes: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <>
      <Toaster
        richColors
        toastOptions={{}}
        position={isDesktop ? 'bottom-left' : 'top-right'}
      />
      <Routes>
        <Route index path="/" element={<CheckoutComponentV2 />} />
        <Route index path="/v2/host-host" element={<HostPageV2 />} />
        <Route
          index
          path="/v2/link/:businessName/:reference"
          element={<PaymentPageV2 />}
        />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route index path="/shop" element={<ShopPage />} />
        <Route index path="/shop/success" element={<ShopSuccessPage />} />
        <Route index path="/shop/error" element={<ShopErrorPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
